<template lang="pug">
  .side-container__content.user-team-aside
    .side-container__header(v-if="asideData.title || asideData.subtitle")
      p.side-container__title.-dark-(v-if="asideData.title")
        | {{asideData.title}}
      p.side-container__subtitle(v-if="asideData.subtitle")
        | {{asideData.subtitle}}
    .side-container__body.-full-
      FullSelect(
        v-model="team"

        :title="asideData.user.name"
        :option="captainTeamList"

        :loading="isLoadingGroup"
      )

    .side-container__footer.-end-
      UiButton(
        @click="changeTeam"
      ) Сохранить

</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';

import FullSelect from './FullSelect';
import counterNameFilter from '@/filters/counterName.filter';

export default {
  components: {
    FullSelect
  },
  props: {
    asideObject: {
      type: Object,
      default: () => ({
        aside: {
          data: {
            user: {
              id: null,
              name: '',
              teamId: null
            }
          },
          meta: {}
        }
      })
    }
  },
  data: () => ({
    team: 1,
    teamList: [],
    isLoadingGroup: false
  }),
  computed: {
    ...mapState('teamGroup', {
      captainList: s => s.data.settings.captains
    }),
    asideData() {
      return this.asideObject.aside ? this.asideObject.aside.data : {};
    },
    asideMeta() {
      return this.asideObject.aside ? this.asideObject.aside.meta : {};
    },
    captainTeamList() {
      return this.teamList.map(team => {
        const captain = this.captainList.find(({ id }) => team.captain === id);
        return {
          id: team.id,
          mainTitle: this.currentNamesUserCount(team.count),
          mainValue: team.team,
          secondTitle: captain ? 'Капитан' : '',
          secondValue: captain ? `${captain.name}  ${captain.lastname}` : ''
        };
      });
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    ...mapActions('asides', ['closeAside', 'updateAsideMetaPath']),
    initData() {
      this.team = this.asideData.user.teamId;
      this.getTeam();
    },
    async changeTeam() {
      this.showLoader();
      const res = await this.$store.dispatch('teamGroup/userTeamChange', {
        user: this.asideData.user.id,
        team: this.team,
        oldTeam: this.asideData.user.teamId
      });
      if (res.status === 'success') {
        this.closeAside({ name: this.asideObject.aside.data.name });
      }

      this.unshowLoader();
    },
    showLoader() {
      this.updateAsideMetaPath({
        asideIndex: this.asideObject.asideIndex,
        path: 'showLoader',
        value: true
      });
    },
    unshowLoader() {
      this.updateAsideMetaPath({
        asideIndex: this.asideObject.asideIndex,
        path: 'showLoader',
        value: false
      });
    },
    async getTeam() {
      this.isLoadingGroup = true;
      let res = {};
      if (this.asideData.user.groupId !== undefined) {
        res = await this.$store.dispatch('teamGroup/getTeamByGroup', {
          id: this.asideData.user.groupId
        });
      } else {
        res = await this.$store.dispatch('teamGroup/getTeamByFolder', {
          id: this.asideData.user.folderId
        });
      }

      if (res.status === 'success') {
        this.teamList = _.cloneDeep(res.data);
      }
      this.isLoadingGroup = false;
    },
    currentNamesUserCount(counter) {
      const names = ['участник', 'участника', 'участников'];
      return counterNameFilter(+counter, names);
    }
  }
};
</script>
